import { render, staticRenderFns } from "./DataIteratorSortBy.vue?vue&type=template&id=6ddb30eb&scoped=true"
import script from "./DataIteratorSortBy.vue?vue&type=script&lang=js"
export * from "./DataIteratorSortBy.vue?vue&type=script&lang=js"
import style0 from "./DataIteratorSortBy.vue?vue&type=style&index=0&id=6ddb30eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddb30eb",
  null
  
)

export default component.exports